import React, { Component, useLayoutEffect, useState, useEffect } from 'react';
import {Redirect} from "react-router-dom";

import InfiniteScroll from "react-infinite-scroll-component";
import DesignResourcesPanel from "../designResourcesPanel";
import {Fetch} from '../../utils';
import ImageBox from "../../components/ImageBox";
import Loader from "../../components/Loader";
import './style.css';

const { feline_fetch } = Fetch;
const PageSize = 50;

const useWindowSize = () => {
    const [size, set_size] = useState([0, 0]);
    useLayoutEffect(() => {
        function update_size() {
            set_size([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', update_size);
        update_size();
        return () => window.removeEventListener('resize', update_size);
    }, []);

    return size;
}


const TemplateGrid = ({ templates, fetch_more, initial_fetch_complete, template_on_click, query_string, ThumbnailContextMenu }) => {
    try {
        const [width, height] = useWindowSize();
        const [ box_width, set_box_width ] = useState();
        const [ box_height, set_box_height ] = useState();
        const [ show_loader, set_show_loader ] = useState(true);
        const [ show_no_results_message, set_show_no_results_message ] = useState(false);

        useEffect(() => {
            let available_width = width - 232;
            let card_count = Math.floor(available_width / 300);
            let card_width = Math.floor(available_width/card_count)-50;
            set_box_width(card_width);
            set_box_height(card_width*1.2);
            // console.log(' dimensions ===> ', width, height, available_width, card_count, card_width);
        }, [ width, height ]);

        //manage no results message visibility
        useEffect(() => {
            if (!(templates && templates.length)) {
                if (initial_fetch_complete) {
                    set_show_no_results_message(true);
                }
            } else {
                set_show_no_results_message(false);
            }
        }, [ templates ])

        //manage loader visibility
        useEffect(() => {
            if (initial_fetch_complete) {
                set_show_loader(false);
            }
        }, [ initial_fetch_complete ])
        
        return (show_loader ? (
            <Loader 
                show_loader={show_loader}
                style={{ width: '75%', height: 350, position: 'relative' }}
            />
        ) : (show_no_results_message ? (
                <div style={{ marginLeft: 10, marginTop: 20 }}>
                   Oops! Your search {query_string ? (<>for  <span style={{ fontWeight: 'bold' }}>{query_string}</span></>) : ''} did not return any results.                   
                </div>                
            ) :(
                <InfiniteScroll
                    dataLength={templates ? templates.length : 0}
                    next={fetch_more}
                    hasMore={true}
                    height={'calc(100vh - 150px)'}
                    endMessage={<h4>No more results.</h4>}
                >
                    {(templates && templates.length) ? templates.map((element, idx) => (
                        <ImageBox
                            key={'design-templates-dashboard' + idx}
                            idx={idx}
                            image_src={global.config.static_file_server_path + element.thumbnail}
                            name={element.name}
                            disable_overlay={true}
                            image_style={{
                                maxWidth: box_width,
                                maxHeight: box_height,
                                height: 'unset',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                objectFit: 'contain',
                                display: 'block',
                                boxShadow: '0 0 8px 0 rgba(66,66,66,0.5)'
                            }}
                            container_style={{width: box_width + 15}}
                            context_menu={
                                <ThumbnailContextMenu 
                                    design={element} 
                                    template={true}
                                    preview_page={false} 
                                />
                            }
                            on_click={() => template_on_click(element, { _id: element.categories[0] })}
                            skeleton={true}
                            skeleton_width={box_width+15}
                            skeleton_height={box_height+15}
                            boxed_view={true}
                            max_container_height={box_height+15}
                        />
                    )): ''}
                </InfiniteScroll>
            )
        ));
    } catch(err) {
        console.error(err);
        return 'Oops something went wrong';
    }
}

class TemplateSearch extends Component {

    constructor(props) {

        super(props);
        this.state = {
            page: 0,
            data: [],
            redirect: false,
            redirect_url: null,
            initial_fetch_complete: false,
            query_string: ''
        }
    }

    componentDidMount() {
        this.fetchSearchResults();
    }

    fetchSearchResults = async () => {

        const query = new URLSearchParams(this.props.location.search);

        let queryStr = query.get("query");
        let category = query.get("category");
        let id = query.get("id");

        let url = global.config.server_path + 'design_templates/_search?';

        if (id && id !== "") {
            var data = await feline_fetch({ url: 'design/get_one', body: { id } });
            console.log(data);
            this.setState({ initial_fetch_complete: true, data: [ data ] });
        } else if (category && category !== "") {

            let url = global.config.server_path + 'design/get/';

            let payload = {
                category_id: category,
                active: true,
                page_no : this.state.page,
                size : 40
            };

            fetch(url, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                'credentials': 'include',
                body: JSON.stringify(payload)
            })
                .then(resp => resp.json())
                .then(resp => {
                    let searchResults = resp.data.docs;
                    if (searchResults) {
                        this.setState({
                            initial_fetch_complete: true,
                            data: this.state.data.concat(searchResults),
                            page: this.state.page + 1
                        })
                    }
                })
                .catch(err => console.error(err))

        } else if (queryStr && queryStr !== "") {

            let queryBody = {
                "from": (this.state.page * PageSize),
                "size": PageSize,
                "query": {
                    "bool": {
                        "must": {
                            "multi_match": {
                                "query": queryStr,
                                "fields": ["categories.name", "keywords^3", "name", "design_text"],
                                "operator": "or",
                                "type": "best_fields"
                            }
                        },
                        "filter": []
                    }
                }
            };

            queryBody["query"]["bool"]["filter"].push({"term": {"active": true}});

            fetch(url, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(queryBody)})
                .then(resp => resp.json())
                .then(resp => resp.hits.hits.map(x => x._id))
                .then(resp => {
                    let url = global.config.server_path + 'design/get/';
                    let payload = {
                        id: resp,
                        active: true
                    };
                    // if (this.state.selectedCategory.value) payload['category_id'] = this.state.selectedCategory.value;
                    return fetch(url, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        'credentials': 'include',
                        body: JSON.stringify(payload)
                    });
                })
                .then(resp => resp.json())
                .then(resp => {
                    let searchResults = resp.data.docs;
                    if (searchResults) {
                        this.setState({
                            initial_fetch_complete: true,
                            data: this.state.data.concat(searchResults),
                            page: this.state.page + 1,
                            query_string: queryStr
                        })
                    }
                })
                .catch(err => console.log(err))
        }
    };

    redirect_page = (url) => {
        this.setState({redirect_url:url,redirect:true})
    };

    render() {

        let {redirect, redirect_url} = this.state;

        if (redirect) {
            return (<Redirect push to={redirect_url} />)
        }

        const query = new URLSearchParams(this.props.location.search);
        let queryStr = query.get("query");
        return (
            <>
                {/* <Helmet> */}
                {/*     <title> Template search results</title> */}
                {/*     <meta property="og:title" content="Random template search results" /> */}
                {/*     <meta property="og:image" content="https://ahrefs.com/blog/wp-content/uploads/2020/01/fb-open-graph-1.jpg" /> */}
                {/* </Helmet> */}
                <div style={{fontWeight: 'bold', fontSize: 12, cursor: 'pointer', zIndex:'500', position:'relative', paddingTop: 15, paddingLeft: 10}} onClick={() => this.redirect_page('/designmaker/start')}><span className="fas fa-chevron-left" /> Back </div>
                <h2 style={{paddingLeft: 10}}>{queryStr}</h2>
                <TemplateGrid 
                    initial_fetch_complete={this.state.initial_fetch_complete}
                    templates={this.state.data}
                    fetch_more={this.fetchSearchResults}
                    ThumbnailContextMenu={this.props.ThumbnailContextMenu}
                    template_on_click={this.props.templateOnClick}
                    query_string={this.state.query_string}
                />                
            </>
        );
    }

}

export default TemplateSearch;